import { ossImage, ossHttpVersion } from '@/utils/oss_image'

export const ossImageFilter = (value, width, height, mode) =>
  value ? ossImage({ src: value, width, height, mode }) : ''

export const ossHttpVersionFilter = src => {
  return ossHttpVersion(src)
}
